import { observable, runInAction } from "mobx"

import { fetchGetShortInternshipsById } from "~/api/short-internships/[id]/get"
import { fetchGetShortInternships } from "~/api/short-internships/get"
import { PageInfo } from "~/entities/PageInfo"
import { ShortInternship } from "~/entities/ShortInternship"

interface FetchArgs {
  number?: number
  page?: number
}

export default class ShortInternshipStore {
  @observable shortInternship: ShortInternship | null = null
  @observable shortInternships: Array<ShortInternship> = []
  @observable pageInfo: PageInfo | null = null

  fetch = async (args?: FetchArgs): Promise<{ shortInternships: ShortInternship[]; pageInfo: PageInfo | null }> => {
    const res = await fetchGetShortInternships({ page: args?.page })
    const data = res.data.map((datum) => {
      return new ShortInternship(datum as any)
    })
    const pageInfo = new PageInfo({
      currentPage: res.meta.current_page,
      lastPage: res.meta.last_page,
      perPage: res.meta.per_page,
      path: res.meta.path,
      from: res.meta.from,
      to: res.meta.to,
      total: res.meta.total,
    })
    runInAction(() => {
      this.shortInternships = data
      this.pageInfo = pageInfo
    })
    return {
      shortInternships: args && args.number ? this.shortInternships.slice(0, args.number) : this.shortInternships,
      pageInfo: this.pageInfo,
    }
  }

  fetchById = async (id: number): Promise<ShortInternship | null> => {
    const shortInternship = await fetchGetShortInternshipsById(id)
    if (shortInternship && shortInternship.id) {
      runInAction(() => {
        this.shortInternship = new ShortInternship(shortInternship as any)
      })
    }
    return this.shortInternship
  }
}
